<template>
  <div
    :id="modalId"
    class="modal fade"
    :class="{ 'landing-experiencia': !!styleVars }"
    :style="styleVars"
    tabindex="-1"
    :aria-labelledby="`${modalId}Label`"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 :id="`${modalId}Label`" class="modal-title text-landing semibold translate">
            {{ title }}
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div v-sanitize-html="content" class="translate"></div>
          <template v-if="adjuntos && adjuntos.length > 0">
            <div class="d-flex align-items-center gap-2 mb-2 mt-3">
              <CustomIcon :icon="folderIcon" size="16px" class="text-landing" />
              <span class="text-landing semibold p">{{ $t('builder.title.files') }}</span>
            </div>
            <div class="row g-2">
              <div v-for="(adjunto, idx) in adjuntos" :key="idx" class="col-12 col-md-6">
                <a
                  :href="adjunto.url"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="adjunto-link d-flex align-items-center justify-content-between text-decoration-none"
                  download>
                  <span class="adjunto-nombre text-landing p text-truncate me-2">{{ adjunto.nombre }}</span>
                  <CustomIcon :icon="downloadIcon" size="16px" class="text-landing" />
                </a>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import downloadIcon from '@/assets/icons/download.svg';
  import folderIcon from '@/assets/icons/folder.svg';
  import CustomIcon from '@components/CustomIcon.vue';

  defineProps({
    modalId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
    adjuntos: {
      type: Array,
      required: true,
    },
    styleVars: {
      type: Object,
      default: null,
    },
  });
</script>

<style lang="scss" scoped>
  .adjunto-link {
    border: 1px solid rgba(var(--landing-text-color-rgb, var(--bs-primary-rgb)), 0.2);
    border-radius: 12px;
    padding: 12px 15px;
    background-color: var(--landing-background-color, var(--bs-white));
    transition: background-color 0.2s ease, border-color 0.2s ease;
    cursor: pointer;
  }

  .adjunto-link:hover {
    background-color: rgba(var(--landing-text-color-rgb, var(--bs-primary-rgb)), 0.05);
    border-color: rgba(var(--landing-text-color-rgb, var(--bs-primary-rgb)), 0.4);
  }

  .adjunto-nombre {
    max-width: calc(100% - 24px);
  }
</style>
